<div class="class mb-3 form-floating">
  <label>{{ label() }}</label>
  <input
    [class.is-invalid]="control.touched && control.invalid"
    [type]="type()"
    class="form-control"
    [formControl]="control"
    placeholder="{{ label() }}"
  />

  <div *ngIf="control.hasError('required') && control.touched" class="invalid-feedback text-start">
    Please enter a {{ label() }}
  </div>

  <div *ngIf="ngControl.control.errors?.minlength && control.touched" class="invalid-feedback">
    {{ label() }} must be at least {{ ngControl.control.errors.minlength["requiredLength"] }} characters
  </div>

  <div *ngIf="ngControl.control.errors?.maxlength && control.touched" class="invalid-feedback">
    {{ label() }} must be at most {{ ngControl.control.errors.maxlength["requiredLength"] }} characters
  </div>

  <div *ngIf="control.hasError('isMatching') && control.touched" class="invalid-feedback text-start">
    Passwords do not match
  </div>

  <div *ngIf="control.hasError('email') && control.touched" class="invalid-feedback text-start">
    {{ label() }} is not valid
  </div>
</div>
